module.exports = __webpack_public_path__ + "static/img/small.3debc84b.svg";